module.exports = "/_next/static/images/9bba81a594e265902c639d53117f42ef-rewards-home-card@1x.png.webp";